import styled, { css } from "styled-components";


export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  user-select: none;
  overflow: hidden;
  z-index: 9999;

  & > img {
    position: absolute;
  }
`;

export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .65);
`;

export const IconWrap = styled.div`
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  cursor: pointer;

  svg {
    opacity: 0.7;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;


export const Ctrls = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 25px;
  background-color: rgba(0, 0, 0, 0.5);
  height: 50px;
  padding: 0 20px;
  color: #fff;

  .icon-wrap {
    height: 100%;
    width: 50px;
    /* opacity: 0; */
    background-color: rgba(0, 0, 0, 0);

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }

    svg {
      opacity: 0.7;
    }
  }
`;


export const BtnPrev = styled(IconWrap)`
  left: 50px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  width: 70px;
  height: 70px;
`;

export const BtnNext = styled(IconWrap)`
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  width: 70px;
  height: 70px;
`;


export const BtnClose = styled(IconWrap)`
  right: 50px;
  top: 50px;
  /* transform: translateY(-50%); */
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;
